<template>
    <div class="group-item-setting-view">
        <div v-if="addShow" class="sub-header">
            <div class="front-block">
                <div class="handle"></div>
                <div class="title">群組名稱</div>
            </div>
        </div>
        <DraggableWrapper
            :value="value"
            :onDragEnd="onDragEnd"
            :onAdd="onAdd"
            :onChange="onChange"
            :onEdit="onEdit"
            :addShow="addShow"
            :activeSno="activeSno"
            :isShowMem="true"
            :isSysAllow="!isIncomeStatement"
            @input="val => $emit('input', val)"
        >
        </DraggableWrapper>
    </div>
</template>

<script>
import DraggableWrapper from './DraggableWrapper.vue';

export default {
    props: {
        value: Array,

        onDragEnd: { type: Function, default: () => {} },
        onChange: { type: Function, default: () => {} },
        onEdit: { type: Function, default: () => {} },
        onAdd: { type: Function, default: () => {} },

        addShow: Boolean,
        activeSno: [Number, String],
        activeCategory: [Number, String],
    },
    computed: {
        isIncomeStatement() {
            return this.activeCategory === 'invoiceSettings' || this.activeCategory === 'payoutSettings' || this.activeCategory === 'cInSettings' || this.activeCategory === 'cOutSettings';
        },
    },
    components: { DraggableWrapper },
};
</script>

<style lang="scss">
.group-item-setting-view {
    .front-block {
        display: flex;
        align-items: center;
        flex: 1;
        .name {
            display: flex;
            width: 230px;
            white-space: nowrap;
            overflow: hidden;
            flex: 1;

            .item-mem {
                color: #aaa;
                padding: 0 0 0 15px;
                font-size: 9pt;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    &.group-setting-group-list {
        .front-block > .name {
            width: 230px;
        }
    }
    &.group-setting-item-list {
        .front-block > .name {
            width: 430px;
        }
    }
}
</style>
